import { useEffect, useState } from 'react'
import {
  Box,
  Flex,
  TabPanel,
  TabPanels,
  Tabs
} from "@chakra-ui/react";
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';



export const DefaultPageSettingsModal = ({
  pageId,
  pageTitle,
  handleClosePageSettingsModal,
  handleEditPageData,
}) => {

  const [displayedPageName, setDisplayedPageName] = useState('');
  const [error, setError] = useState('');

  const nameCharacterLimit = 50;

  useEffect(() => {
    if (pageTitle) {
      setDisplayedPageName(pageTitle)
    }
  }, [pageTitle]);


  const handleClickClosePageSettingsModal = () => {
    setError('')
    setDisplayedPageName("")
    handleClosePageSettingsModal()
  }

  const onChangeHandler = (event) => {
    setError('')

    setDisplayedPageName(event.target.value)
  };

  const handleSavePageSettings = () => {
    if (displayedPageName.length <= 0) {
      setError('pageName')
      return;
    }

    if (!error) {
      let customPageData = {};

      if (displayedPageName !== pageTitle) {
        customPageData.altPageTitle = displayedPageName;
      }

      if (Object.keys(customPageData).length > 0 && pageId) {
        handleEditPageData(customPageData, pageId)
      }

      handleClickClosePageSettingsModal()
    }
  }
  return (
    <LaunchdeckModal
      title='Page settings'
      handleCloseModal={handleClickClosePageSettingsModal}
      showModal={true}
      maxW='35em'
    >
      
      <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
        <Box width='100%'>
          <Tabs width='100%'>
            <TabPanels padding='24px'>
              <TabPanel>
                <LaunchdeckFormInput
                  label='Page name'
                  name={'pageName'}
                  onChange={onChangeHandler}
                  value={displayedPageName}
                  placeholder="Enter page name"
                  isRequired={true}

                  charLimit={nameCharacterLimit}

                  errorLogic={error === 'pageName'}
                  errorMessage={'Give your page a name'}
                />

                <Flex align='center' justify='flex-end' mt='2em' w='100%'>
                  <LaunchdeckButton bg='brand.500' color='white' onClick={handleSavePageSettings} px='0.5em' label='OK' />
                </Flex>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Flex>

    </LaunchdeckModal>
  )
}
